<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="输入项目名称模糊检索" prefix-icon="el-icon-search"
                              clearable
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div>
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <el-button type="success" @click="importData" icon="el-icon-download">
                        {{importDataBtnText}}
                    </el-button>
                    <el-button type="success" @click="exportData" icon="el-icon-download">
                        导出项目
                    </el-button>
                    <el-button type="success" @click="exportTask" icon="el-icon-download">
                        导出任务
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加项目
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="5">
                            项目名称:
                            <el-input v-model="searchValue.projectName" placeholder="项目名称" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            类型:
                            <el-select v-model="searchValue.type" clearable="" placeholder="类型" size="mini"
                                       style="width: 130px;">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            下单平台:
                            <el-select v-model="searchValue.plat" clearable="" placeholder="下单平台" size="mini" style="width: 130px;">
                                <el-option
                                        v-for="item in platList"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            订单来源:
                            <el-select v-model="searchValue.source" clearable="" placeholder="订单来源" size="mini" style="width: 130px;">
                                <el-option
                                        v-for="item in sourceList"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3">
                            项目经理:
                             <el-input v-model="searchValue.projectMaster" placeholder="项目经理" size="mini"
                                       style="width: 130px;"></el-input>
                            <!-- 所属部门:
                            <el-popover
                                    placement="right"
                                    title="请选择部门"
                                    width="200"
                                    trigger="manual"
                                    v-model="popVisible2">
                                <el-tree default-expand-all :data="allDeps" :props="defaultProps"
                                         @node-click="searvhViewHandleNodeClick"></el-tree>
                                <div slot="reference"
                                     style="width: 130px;display: inline-flex;font-size: 13px;border: 1px solid #dedede;height: 26px;border-radius: 5px;cursor: pointer;align-items: center;padding-left: 8px;box-sizing: border-box;margin-left: 3px"
                                     @click="showDepView2">{{inputDepName}}
                                </div>
                            </el-popover> -->
                        </el-col>
                        <!-- <el-col :span="7">
                            聘用形式:
                            <el-radio-group v-model="searchValue.engageForm">
                                <el-radio label="劳动合同">劳动合同</el-radio>
                                <el-radio label="劳务合同">劳务合同</el-radio>
                            </el-radio-group>
                        </el-col> -->
                    </el-row>
                    <el-row style="margin-top: 10px">
                        
   
                        <el-col :span="7">
                            推送日期:
                            <el-date-picker
                                    v-model="searchValue.beginDateScope"
                                    type="daterange"
                                    size="mini"
                                    unlink-panels
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="7">
                            应反馈日期:
                            <el-date-picker
                                    v-model="searchValue.beginPlanDateScope"
                                    type="daterange"
                                    size="mini"
                                    unlink-panels
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="5" :offset="4">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%"
                    :row-key="row=>row.projectCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="projectName"
                        fixed
                        align="left"
                        label="项目名称"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="type"
                        width="70"
                        align="center"
                        label="类型">
                         <template slot-scope="scope">
                             {{getChangeType(scope.row.type,'type')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="plat"
                        width="80"
                        align="center"
                        label="下单平台">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.plat,'plat')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="source"
                        width="80"
                        align="center"
                        label="订单来源">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.source,'source')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="projectMaster"
                        width="80"
                        align="center"
                        label="项目经理">
                </el-table-column>
                <el-table-column
                        prop="totalPrice"
                        width="80"
                        align="center"
                        label="总价">
                </el-table-column>
                <el-table-column
                        prop="premium"
                        width="95"
                        align="center"
                        label="提成">
                </el-table-column>
                <el-table-column
                        prop="totalCost"
                        width="95"
                        align="center"
                        label="总花费">
                </el-table-column>
                <el-table-column
                        prop="profitMargin"
                        width="95"
                        align="center"
                        label="利润率">
                </el-table-column>
                <el-table-column
                        prop="resourceNum"
                        width="95"
                        align="center"
                        label="资源数">
                </el-table-column>
                <el-table-column
                        prop="planStartTime"
                        width="95"
                        align="center"
                        label="推送日期">
                </el-table-column>
                <el-table-column
                        prop="planTime"
                        width="95"
                        align="center"
                        label="应反馈日期">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        width="150"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="mark"
                        width="150"
                        align="center"
                        label="备注">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="260"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" v-if="scope.row.plat == '01'" style="padding: 3px" size="mini">补单</el-button>
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <el-col :span="24">
                    下单平台:<el-select v-model="upFilePlat" clearable="" placeholder="下单平台" size="mini">
                        <el-option
                                v-for="item in platList"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                        </el-option>
                    </el-select>
                </el-col>
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>


        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目名称:" prop="projectName">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.projectName"
                                          placeholder="请输入项目名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="下单平台:" prop="plat">
                                <el-select v-model="emp.plat" clearable="" placeholder="下单平台" size="mini">
                                    <el-option
                                            v-for="item in platList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="项目类型:" prop="type">
                                <el-select v-model="emp.type" clearable="" placeholder="项目类型" size="mini">
                                    <el-option
                                            v-for="item in typeList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="项目来源:" prop="source">
                                <el-select v-model="emp.source" clearable="" placeholder="项目来源" size="mini">
                                    <el-option
                                            v-for="item in sourceList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目经理:" prop="projectMaster">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.projectMaster"
                                          placeholder="前程、猎聘的不填"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="下单日期:" prop="createTimePlat">
                                <el-date-picker
                                        v-model="emp.createTimePlat"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="下单日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="推送时间:" prop="planStartTime">
                                <el-date-picker
                                        v-model="emp.planStartTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="推送时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="反馈日期:" prop="planTime">
                                <el-date-picker
                                        v-model="emp.planTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="反馈日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="" prop="totalPrice">
                                <label>总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.totalPrice"
                                          placeholder="售卖总价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="" prop="premium">
                                <label>提&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;成:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.premium"
                                          placeholder="提成"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="" prop="totalCost">
                                <label>总&nbsp;&nbsp;花&nbsp;&nbsp;费:&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.totalCost"
                                          placeholder="总花费"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="" prop="resourceNum">
                                <label>资&nbsp;&nbsp;源&nbsp;&nbsp;数:&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.resourceNum"
                                          placeholder="资源数"></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <!-- <el-row>
                        <el-col :span="6">
                            <el-form-item label="工号:" prop="workID">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit"
                                          v-model="emp.workID" placeholder="工号" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="学历:" prop="tiptopDegree">
                                <el-select v-model="emp.tiptopDegree" placeholder="学历" size="mini"
                                           style="width: 150px;">
                                    <el-option
                                            v-for="item in tiptopDegrees"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="毕业院校:" prop="school">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit"
                                          v-model="emp.school" placeholder="毕业院校名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="专业名称:" prop="specialty">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit"
                                          v-model="emp.specialty" placeholder="请输入专业名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="入职日期:" prop="beginDate">
                                <el-date-picker
                                        v-model="emp.beginDate"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 130px;"
                                        placeholder="入职日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="转正日期:" prop="conversionTime">
                                <el-date-picker
                                        v-model="emp.conversionTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 130px;"
                                        placeholder="转正日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合同起始日期:" prop="beginContract">
                                <el-date-picker
                                        v-model="emp.beginContract"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 130px;"
                                        placeholder="合同起始日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合同终止日期:" prop="endContract">
                                <el-date-picker
                                        v-model="emp.endContract"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="合同终止日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="身份证号码:" prop="idCard">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit"
                                          v-model="emp.idCard" placeholder="请输入身份证号码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="聘用形式:" prop="engageForm">
                                <el-radio-group v-model="emp.engageForm">
                                    <el-radio label="劳动合同">劳动合同</el-radio>
                                    <el-radio label="劳务合同">劳务合同</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="婚姻状况:" prop="wedlock">
                                <el-radio-group v-model="emp.wedlock">
                                    <el-radio label="已婚">已婚</el-radio>
                                    <el-radio label="未婚">未婚</el-radio>
                                    <el-radio label="离异">离异</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddEmp">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null
                },
                typeList: [{
                    dictValue: '01',
                    dictLabel: '微信'
                    }, {
                    dictValue: '02',
                    dictLabel: 'QQ'
                    }, {
                    dictValue: '03',
                    dictLabel: '公众号'
                }],
                platList: [{
                    dictValue: '01',
                    dictLabel: '智联'
                    }, {
                    dictValue: '02',
                    dictLabel: '前程'
                    }, {
                    dictValue: '03',
                    dictLabel: '猎聘'
                    }, {
                    dictValue: '04',
                    dictLabel: '销售'
                }],
                sourceList: [
                    {
                        dictValue: '01',
                        dictLabel: '自然流量'
                    }, 
                    {
                        dictValue: '02',
                        dictLabel: '销售引入'
                    }
                ],
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                emps: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                inputDepName: '所属部门',
                emp: {
                    name: "javaboy",
                    gender: "男",
                    birthday: "1989-12-31",
                    idCard: "610122199001011256",
                    wedlock: "已婚",
                    nationId: 1,
                    nativePlace: "陕西",
                    politicId: 13,
                    email: "laowang@qq.com",
                    phone: "18565558897",
                    address: "深圳市南山区",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "劳务合同",
                    tiptopDegree: "本科",
                    specialty: "信息管理与信息系统",
                    school: "深圳大学",
                    beginDate: "2017-12-31",
                    workState: "在职",
                    workID: "00000057",
                    contractTerm: 2,
                    conversionTime: "2018-03-31",
                    notworkDate: null,
                    beginContract: "2017-12-31",
                    endContract: "2019-12-31",
                    workAge: null
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    gender: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    birthday: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    nationId: [{required: true, message: '请输入您组', trigger: 'blur'}],
                    nativePlace: [{required: true, message: '请输入籍贯', trigger: 'blur'}],
                    politicId: [{required: true, message: '请输入政治面貌', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
                    address: [{required: true, message: '请输入员工地址', trigger: 'blur'}],
                    departmentId: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
                    jobLevelId: [{required: true, message: '请输入职称', trigger: 'blur'}],
                    posId: [{required: true, message: '请输入职位', trigger: 'blur'}],
                    engageForm: [{required: true, message: '请输入聘用形式', trigger: 'blur'}],
                    tiptopDegree: [{required: true, message: '请输入学历', trigger: 'blur'}],
                    specialty: [{required: true, message: '请输入专业', trigger: 'blur'}],
                    school: [{required: true, message: '请输入毕业院校', trigger: 'blur'}],
                    beginDate: [{required: true, message: '请输入入职日期', trigger: 'blur'}],
                    workState: [{required: true, message: '请输入工作状态', trigger: 'blur'}],
                    workID: [{required: true, message: '请输入工号', trigger: 'blur'}],
                    contractTerm: [{required: true, message: '请输入合同期限', trigger: 'blur'}],
                    conversionTime: [{required: true, message: '请输入转正日期', trigger: 'blur'}],
                    notworkDate: [{required: true, message: '请输入离职日期', trigger: 'blur'}],
                    beginContract: [{required: true, message: '请输入合同起始日期', trigger: 'blur'}],
                    endContract: [{required: true, message: '请输入合同结束日期', trigger: 'blur'}],
                    workAge: [{required: true, message: '请输入工龄', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
            this.initPositions();
        },
        methods: {
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('type' == z){
                    for (var i = 0; i < this.typeList.length; i++) {
                        if (this.typeList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.typeList[i].dictLabel;
                        }
                    }
                }else if('plat' == z){
                    for (var i = 0; i < this.platList.length; i++) {
                        if (this.platList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.platList[i].dictLabel;
                        }
                    }
                }else if('source' == z){
                    for (var i = 0; i < this.sourceList.length; i++) {
                        if (this.sourceList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.sourceList[i].dictLabel;
                        }
                    }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportData() {
                let a = this.$refs.projectTable.selection
                window.open('/employee/basic/export', '_parent');
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name: "",
                    gender: "",
                    birthday: "",
                    idCard: "",
                    wedlock: "",
                    nationId: 1,
                    nativePlace: "",
                    politicId: 13,
                    email: "",
                    phone: "",
                    address: "",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "",
                    tiptopDegree: "",
                    specialty: "",
                    school: "",
                    beginDate: "",
                    workID: "",
                    contractTerm: 2,
                    conversionTime: "",
                    notworkDate: null,
                    beginContract: "",
                    endContract: "",
                    workAge: null
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
                // this.initPositions();
                this.title = '编辑项目信息';
                this.emp = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/project/putProject", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/project/addProject", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initPositions() {
                this.getRequest('/employee/basic/positions').then(resp => {
                    if (resp) {
                        this.positions = resp;
                    }
                })
            },
            getMaxWordID() {
                this.getRequest("/employee/basic/maxWorkID").then(resp => {
                    if (resp) {
                        this.emp.workID = resp.obj;
                    }
                })
            },
            initData() {
                if (!window.sessionStorage.getItem("nations")) {
                    this.getRequest('/employee/basic/nations').then(resp => {
                        if (resp) {
                            this.nations = resp;
                            window.sessionStorage.setItem("nations", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.nations = JSON.parse(window.sessionStorage.getItem("nations"));
                }
                if (!window.sessionStorage.getItem("joblevels")) {
                    this.getRequest('/employee/basic/joblevels').then(resp => {
                        if (resp) {
                            this.joblevels = resp;
                            window.sessionStorage.setItem("joblevels", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.joblevels = JSON.parse(window.sessionStorage.getItem("joblevels"));
                }
                if (!window.sessionStorage.getItem("politicsstatus")) {
                    this.getRequest('/employee/basic/politicsstatus').then(resp => {
                        if (resp) {
                            this.politicsstatus = resp;
                            window.sessionStorage.setItem("politicsstatus", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.politicsstatus = JSON.parse(window.sessionStorage.getItem("politicsstatus"));
                }
                if (!window.sessionStorage.getItem("deps")) {
                    this.getRequest('/employee/basic/deps').then(resp => {
                        if (resp) {
                            this.allDeps = resp;
                            window.sessionStorage.setItem("deps", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.allDeps = JSON.parse(window.sessionStorage.getItem("deps"));
                }
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加项目';
                this.getMaxWordID();
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['projectNameLike']=this.keyword
                this.searchValue['index']=this.page
                this.searchValue['pageSize']=this.size
                this.postRequest('/yl/project/getProject', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
